var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("icon-button", {
    staticClass: "button--scroll-to-top",
    attrs: { icon: "chevron-up", "aria-label": "Scroll To Top" },
    on: { click: _vm.scrollToTop }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }